<div class="event-form-wrap">
    <ig-row>
        <ig-col [xs]="12" [lg]="12">
            <form class="event-form" ngForm="eventFormGroup">
                <div class="header">
                    <h2>Add events from eventbrite organizer
                        <mat-icon
                                matTooltip="by organizer: https://www.eventbrite.co.uk/o/development-and-alumni-office-at-goldsmiths-university-of-london-9371883152">
                            info
                        </mat-icon>
                    </h2>
                </div>

                <div class="body">

                    <ig-mat-field
                            label="Enter eventbrite organizer url"
                            [(ngModel)]="eventPage.facebookPageUrlOrName"
                            [isRequired]="true"
                            [formControl]="eventFormGroup.get('facebookPageUrlOrName')"
                    ></ig-mat-field>
                    <ig-mat-field
                            label="Display title (optional)"
                            [(ngModel)]="eventPage.displayTitle"
                            [isRequired]="true"
                            [formControl]="eventFormGroup.get('displayTitle')"
                    ></ig-mat-field>

                    <ig-button color="accent"
                               [isAsync]="true" size="md"
                               [disabled]="eventFormGroup.invalid"
                               (trigger)="addEventBriteOrganizer($event)">
                        Add
                    </ig-button>
                </div>
            </form>
        </ig-col>
    </ig-row>

    <ig-row>
        <ig-col [xs]="12" [lg]="5">
            <form class="event-form"
                  ngForm="locationFormGroup"
                  (keydown.enter)="$event.preventDefault()">
                <div class="header">
                    <h2>Search events by address</h2>
                </div>

                <div class="body">
                    <ig-address-input #addressInput
                                      label="Street, City, State, Zipcode"
                                      [(ngModel)]="autoCompletedAddress"
                                      [isRequired]="true"
                                      (ngModelChange)="findOnMap()"
                                      [formControl]="locationFormGroup.get('address')">
                    </ig-address-input>
                    <ig-mat-field
                            label="Radius (miles)"
                            type="number"
                            [maxValue]="30"
                            [isRequired]="true"
                            [(ngModel)]="eventLocation.radius"
                            [formControl]="locationFormGroup.get('radius')"
                    ></ig-mat-field>

                    <ig-button color="accent" size="md"
                               [disabled]="locationFormGroup.invalid"
                               (trigger)="findOnMap()">
                        FIND ON MAP
                    </ig-button>

                </div>
            </form>
        </ig-col>
        <ig-col [xs]="12" [lg]="7" class="right-map">
            <agm-map [latitude]="eventLocation.lat"
                     [longitude]="eventLocation.lng"
                     [zoom]="zoom">
                <agm-marker *ngIf="isShowMarker"
                            (markerClick)="locationStatus()"
                            [latitude]="eventLocation.lat"
                            [longitude]="eventLocation.lng">
                    <agm-info-window #infoWindow [isOpen]="true">
                        <div class="map-add-wrap">
                            <p>{{isFeedExisted?'Location Already Added':'Add GPS Location'}}</p>
                            <ig-mat-field
                                    label="Display Title"
                                    [(ngModel)]="eventLocation.displayTitle"
                                    [formControl]="locationFormGroup.get('displayTitle')"
                            ></ig-mat-field>
                            <!--<ig-mat-field-->
                            <!--label="Categories (separate with comma)"-->
                            <!--[(ngModel)]="eventLocation.tags"-->
                            <!--[formControl]="locationFormGroup.get('tags')"-->
                            <!--&gt;</ig-mat-field>-->

                            <ig-button *ngIf="!showSuccessInfo" color="accent"
                                       [isAsync]="true" size="md"
                                       [disabled]="locationFormGroup.invalid"
                                       (trigger)="addLocation($event)"
                                       [ngClass]="{'red-btn':isFeedExisted}">
                                {{isFeedExisted?'REMOVE':'ADD'}}
                            </ig-button>
                            <div class="tips" *ngIf="inAddingLocationFeed">this might take a few minutes...</div>
                            <div class="tips" *ngIf="showSuccessInfo">Operation Succeed!</div>
                        </div>
                    </agm-info-window>
                </agm-marker>
                <agm-circle *ngIf="isShowMarker"
                            [latitude]="eventLocation.lat"
                            [longitude]="eventLocation.lng"
                            [radius]="eventLocation.radius*mileToMeters"
                            fillColor="red">
                </agm-circle>
            </agm-map>
        </ig-col>
    </ig-row>
    <ig-row class="page-feed-list event-form">
        <ig-col [xs]="12">
            <div class="header">
                <h2>Edit Feeds</h2>
            </div>
        </ig-col>
        <ig-col [xs]="12">
            <ig-row>
                <ig-col [xs]="12" [md]="6">
                    <ig-list>
                        <div header>
                            <ig-list-column-header>
                                ORGANIZERS
                            </ig-list-column-header>
                        </div>
                        <div body>
                            <ig-list-item *ngFor="let page of hubPages">
                                <div>
                                    {{page.name}}
                                </div>
                                <ig-row-action-buttons>
                                    <mat-icon matTooltip="Delete" (click)="deleteEventFeed(page)">
                                        clear
                                    </mat-icon>
                                </ig-row-action-buttons>
                            </ig-list-item>
                        </div>
                    </ig-list>
                </ig-col>
                <ig-col [xs]="12" [md]="6">
                    <ig-list>
                        <div header>
                            <ig-list-column-header>
                                GEO-LOCATION (GPS/ADDRESS)
                            </ig-list-column-header>
                        </div>
                        <div body>
                            <ig-list-item *ngFor="let location of hubLocations">
                                <div>
                                    {{location.title || location.id}}
                                </div>
                                <ig-row-action-buttons>
                                    <mat-icon matTooltip="Delete" (click)="deleteLocationFeed(location)">
                                        clear
                                    </mat-icon>
                                </ig-row-action-buttons>
                            </ig-list-item>
                        </div>
                    </ig-list>
                </ig-col>
            </ig-row>
        </ig-col>
    </ig-row>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.eventbrite/event.brite.add.component.html